var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    { attrs: { width: "100%", elevation: "0" } },
    [
      _c("v-card-title", { staticClass: "pb-0 pl-1" }, [_vm._v("Products")]),
      _c("div", { staticClass: "pl-1" }, [
        _c("div", [
          _c(
            "div",
            {
              staticClass: "d-flex overline",
              staticStyle: { "align-items": "center", gap: "8px" },
            },
            [
              _c("b", { staticClass: "blue--text" }, [_vm._v("Low product:")]),
              _c(
                "v-btn",
                {
                  attrs: { elevation: "0", "x-small": "", color: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.addRow("lowProducts")
                    },
                  },
                },
                [_vm._v(" Add ")]
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "d-flex",
              staticStyle: { "flex-direction": "column", gap: "6px" },
            },
            _vm._l(_vm.lowProducts, function (entry, index) {
              return _c(
                "div",
                {
                  key: `low-${index}`,
                  staticClass:
                    "tl__product tl__product--low d-flex justify-space-between",
                  staticStyle: { gap: "8px", "align-items": "center" },
                },
                [
                  _c("r-product-dropdown", {
                    attrs: { model: entry.product, clearable: true },
                    on: {
                      "update:model": function ($event) {
                        return _vm.$set(entry, "product", $event)
                      },
                    },
                  }),
                  _c("v-text-field", {
                    staticClass: "col-2 px-0 pb-0",
                    attrs: {
                      label: "Amount",
                      "hide-details": "",
                      type: "number",
                    },
                    model: {
                      value: entry.amount,
                      callback: function ($$v) {
                        _vm.$set(entry, "amount", _vm._n($$v))
                      },
                      expression: "entry.amount",
                    },
                  }),
                  _c(
                    "v-icon",
                    {
                      staticClass: "mr-2",
                      attrs: { small: "", color: "red" },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.removeRow("lowProducts", index)
                        },
                      },
                    },
                    [_vm._v(" mdi-delete ")]
                  ),
                ],
                1
              )
            }),
            0
          ),
        ]),
        _c("div", { staticClass: "my-4" }, [
          _c(
            "div",
            {
              staticClass: "d-flex overline",
              staticStyle: { "align-items": "center", gap: "8px" },
            },
            [
              _c("b", { staticClass: "blue--text" }, [
                _vm._v("Middle product:"),
              ]),
              _c(
                "v-btn",
                {
                  attrs: { elevation: "0", "x-small": "", color: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.addRow("midProducts")
                    },
                  },
                },
                [_vm._v(" Add ")]
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "d-flex",
              staticStyle: { "flex-direction": "column", gap: "6px" },
            },
            _vm._l(_vm.midProducts, function (entry, index) {
              return _c(
                "div",
                {
                  key: `mid-${index}`,
                  staticClass:
                    "tl__product tl__product--mid d-flex justify-space-between",
                  staticStyle: { gap: "8px", "align-items": "center" },
                },
                [
                  _c("r-product-dropdown", {
                    attrs: { model: entry.product, clearable: true },
                    on: {
                      "update:model": function ($event) {
                        return _vm.$set(entry, "product", $event)
                      },
                    },
                  }),
                  _c("v-text-field", {
                    staticClass: "col-2 px-0 pb-0",
                    attrs: {
                      label: "Amount",
                      "hide-details": "",
                      type: "number",
                    },
                    model: {
                      value: entry.amount,
                      callback: function ($$v) {
                        _vm.$set(entry, "amount", _vm._n($$v))
                      },
                      expression: "entry.amount",
                    },
                  }),
                  _c(
                    "v-icon",
                    {
                      staticClass: "mr-2",
                      attrs: { small: "", color: "red" },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.removeRow("midProducts", index)
                        },
                      },
                    },
                    [_vm._v(" mdi-delete ")]
                  ),
                ],
                1
              )
            }),
            0
          ),
        ]),
        _c("div", [
          _c(
            "div",
            {
              staticClass: "d-flex overline",
              staticStyle: { "align-items": "center", gap: "8px" },
            },
            [
              _c("b", { staticClass: "blue--text" }, [_vm._v("High product:")]),
              _c(
                "v-btn",
                {
                  attrs: { elevation: "0", "x-small": "", color: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.addRow("highProducts")
                    },
                  },
                },
                [_vm._v(" Add ")]
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "d-flex",
              staticStyle: { "flex-direction": "column", gap: "6px" },
            },
            _vm._l(_vm.highProducts, function (entry, index) {
              return _c(
                "div",
                {
                  key: `high-${index}`,
                  staticClass:
                    "tl__product tl__product--high d-flex justify-space-between",
                  staticStyle: { gap: "8px", "align-items": "center" },
                },
                [
                  _c("r-product-dropdown", {
                    attrs: { model: entry.product, clearable: true },
                    on: {
                      "update:model": function ($event) {
                        return _vm.$set(entry, "product", $event)
                      },
                    },
                  }),
                  _c("v-text-field", {
                    staticClass: "col-2 px-0 pb-0",
                    attrs: {
                      label: "Amount",
                      "hide-details": "",
                      type: "number",
                    },
                    model: {
                      value: entry.amount,
                      callback: function ($$v) {
                        _vm.$set(entry, "amount", _vm._n($$v))
                      },
                      expression: "entry.amount",
                    },
                  }),
                  _c(
                    "v-icon",
                    {
                      staticClass: "mr-2",
                      attrs: { small: "", color: "red" },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.removeRow("highProducts", index)
                        },
                      },
                    },
                    [_vm._v(" mdi-delete ")]
                  ),
                ],
                1
              )
            }),
            0
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }